var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('nav',[_c('TreeMenu',{attrs:{"items":_vm.items,"max-depth":_vm.maxDepth,"delay":400,"active-ids":_vm.activeMenuItemIDs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }